import { EEntityStatus } from '@/editor/types/entity';
import { IPoint2d } from '../../math/IPoint2d';
import { EEntityType } from '@/editor/types';

export interface IDoorWindowRelateInfo {
  relativeWallId: string;
  wallType?: EEntityType.Wall | EEntityType.SeparateWall;
}

export interface IBaseWindowData {
  relativeWallInfo: IDoorWindowRelateInfo;
  id: string;
  width: number;
  height: number;
  side: EDoorWindowSide; // 默认right
  flip: boolean; // 默认false
  offGround: number;
  distance: number;
  type: EDoorWindowType;
  modelId: string;
}

// 扩展后的门窗数据，默认以relativeWallInfo、distance、side为原始数据，center、rotation、thickness为渲染用数据
// 需要使用syncDistanceTypeToCenterType/syncCenterTypeToDistanceType进行格式转换
// 同步relativeWallInfo、distance、side与center、rotation、thickness
export interface IWindowData extends IBaseWindowData {
  center: IPoint2d;
  rotation: number;
  thickness: number;
}

// 2d  model渲染参数
export interface IWindowRenderParams {
  modelId: string;
  type: EDoorWindowType;
  center: IPoint2d;
  width: number;
  thickness: number;
  height: number;
  offGround: number;
  rotation: number;
  flip: boolean;
  selected: boolean;
  status: EEntityStatus;
  isEntrance: boolean;
}

export interface IUpdateModelParams {
  center: IPoint2d;
  width: number;
  thickness: number;
  height: number;
  offGround: number;
  modelId: string;
  model2d: string;
  model3d: string;
  status: EEntityStatus;
  selected: boolean;
  rotation: number;
  flip: boolean;
  workPoints?: IPoint2d[];
  workPointsVisible?: boolean;
}

interface IRectangleColumnData {
  id: string;
  type: EColumnType.squareColumn;
  center: IPoint2d;
  width: number;
  thickness: number;
  rotation: number;
  height: number;
  offGround: number;
}

interface ICylinderColumnData {
  id: string;
  type: EColumnType.cylinder;
  center: IPoint2d;
  radius: number;
  rotation: number;
  height: number;
  offGround: number;
}

// 使用 Union Type 获得更好的类型推断
export type IColumnData = IRectangleColumnData | ICylinderColumnData;

export enum EColumnType {
  squareColumn = 'squareColumn',
  cylinder = 'cylinder'
}

export enum EDoorWindowType {
  singleDoor = 'singleDoor',
  doubleDoor = 'doubleDoor',
  motherDoor = 'motherDoor',
  window = 'window',
  frenchWindow = 'frenchWindow'
}

export enum EDoorWindowSide {
  left = 'left',
  right = 'right'
}
